import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const testEmployeeWebhook = (axios: IAxiosInstance) => {
  return async ({
    employeeWebhook,
    userType,
    test,
    usePrimary,
  }: ISchema["#/definitions/ITestEmployeeWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ITestEmployeeWebhookResponse"]
    >(`/api/testEmployeeWebhook${getUsePrimaryUrlParams(usePrimary)}`, {
      employee_webhook: employeeWebhook,
      user_type: userType,
      test,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
